$(document).on("turbolinks:load", function () {
  var $adminOrderForm = $(".js-admin-order-form")

  if ($adminOrderForm.length > 0) {
    var $orderSubTotal = $(".js-admin-order-sub-total")
    var $taxAmount = $(".js-admin-order-tax-amount")
    var $orderTotal = $(".js-admin-order-total-amount")
    var $orderItems = $(".js-admin-order-item")

    if ($orderItems.length) {
      $orderItems.each(function () {
        fieldsInit(this)
      })
    }

    $(".new_order, .edit_order")
      .on("cocoon:after-insert", function (e, insertedItem) {
        fieldsInit(insertedItem)
      })
      .on("cocoon:before-remove", function (e, insertedItem) {
        var lineTotal = itemLineTotal(insertedItem)
        if (lineTotal) calcSubTotal(lineTotal)
      })

    $orderSubTotal.on("change input", function () {
      !$(this).val() || $(this).val() <= 0 ? $taxAmount.val(0) : null
      calcOrderTotal()
    })

    $taxAmount.on("input", function () {
      calcOrderTotal()
    })

    function calcSubTotal(subtract = 0) {
      if (subtract) {
        $orderSubTotal
          .val(parseInt($orderSubTotal.val()) - parseInt(subtract))
          .trigger("change")
      } else {
        let $nestedItems = $adminOrderForm.find(".nested-fields")
        let $totalPrice = $.map($nestedItems, itemLineTotal).reduce(
          (sum, price) => sum + price
        )

        $orderSubTotal.val($totalPrice).trigger("change")
      }
    }

    // Unit price × quantity for one nested order item (price is per unit).
    function itemLineTotal(el) {
      var price = parseInt($(el).find(".js-admin-order-item-price").val()) || 0
      var qty = parseInt($(el).find(".js-admin-order-item-qty").val()) || 1
      return price * qty
    }

    function calcOrderTotal() {
      let subTotal = parseInt($orderSubTotal.val()) || 0
      let taxAmount = parseInt($taxAmount.val()) || 0
      $orderTotal.val(subTotal + taxAmount)
    }

    function fieldsInit(element) {
      let $bundleSelects = $(".js-bundle-select")
      let $tierSelect = $(element).find(".js-bundle-tier-select")
      let $productSelects = $(".js-product-select")
      let $variantSelect = $(element).find(".js-product-variant-select")
      let $itemPrice = $(element).find(".js-admin-order-item-price")
      let $itemQty = $(element).find(".js-admin-order-item-qty")
      let $itemName = $(element).find(".js-admin-order-item-name")
      let $itemVendorId = $(element).find(".js-admin-order-item-vendor-id")
      let $itemSaleId = $(element).find(".js-admin-order-item-sale-id")

      $.each($productSelects, function (i, el) {
        $(el).attr("data-number", i) // set indexes for updating variant selects
      })

      $(".js-select").select2({ width: "100%" }) // re-initialize select2

      $productSelects.on("change", function () {
        let $this = $(this)
        let val = $this.find("option:selected").val()
        let inputNumber = $this.data("number")
        $itemPrice.prop("disabled", false)

        if (val !== "") {
          getProductVariants(val, inputNumber)
          getProductDetails(
            val,
            $itemName,
            $itemPrice,
            $itemVendorId,
            $itemSaleId
          )
        }
      })

      $variantSelect.on("change", function () {
        let val = $(this).val()
        if (val) {
          getVariantPrice(val, $itemPrice)
        }
      })

      $bundleSelects.on("change", function () {
        const selected = $(this).select2("data")[0]
        const bundleID = selected.id
        const price = selected.price
        $itemPrice.prop("disabled", false).val(price).trigger("change")

        if (bundleID) updateTierSelect($tierSelect, bundleID)
      })

      $tierSelect.on("change", function () {
        const $this = $(this)
        const tierID = $this.val()

        if (tierID) {
          const price = $(this).find(":selected").data("price")
          $itemPrice.val(price).trigger("change")
        }
      })

      $itemPrice.add($itemQty).on("change input", function () {
        calcSubTotal()
      })
    }

    function updateTierSelect($tierSelect, bundleID) {
      $tierSelect.val(null)
      $tierSelect.trigger("change")
      $tierSelect.html("")

      $.ajax({
        type: "GET",
        url: "/api/site/admin/product_bundles/" + bundleID + "/bundle_tiers",
        dataType: "json",
        success: function (response) {
          if (response.results.length) {
            $tierSelect.prop("disabled", false)

            response.results.forEach(function (variant, index) {
              const isSelected = index === 0 // pre-select the first item
              const option = new Option(
                variant.text,
                variant.id,
                isSelected,
                isSelected
              )
              $(option).data("price", variant.price)
              $tierSelect.append(option).trigger("change")
            })
          } else {
            // disable tier select
            $tierSelect
              .prop("disabled", true)
              .append(new Option("No tiers available", ""))
          }
        },
      })
    }

    function getProductDetails(
      id,
      $nameField,
      $priceField,
      $vendorIdField,
      $saleIdField
    ) {
      $.ajax({
        type: "GET",
        url: "/api/site/products/" + id,
        dataType: "json",
        success: function (response) {
          updateItemDetails(
            $nameField,
            $priceField,
            $vendorIdField,
            $saleIdField,
            response
          )
        },
      })
    }

    function getProductVariants(id, inputNumber) {
      $.ajax({
        type: "GET",
        url: "/product_variants?product=" + id + "&input_number=" + inputNumber,
        dataType: "script",
      })
    }

    function getVariantPrice(id, $priceField) {
      $.ajax({
        type: "GET",
        url: "/api/site/product_variants/" + id,
        dataType: "json",
        success: function (response) {
          $priceField.val(response["price"]).trigger("change")
        },
      })
    }

    function updateItemDetails(
      $nameField,
      $priceField,
      $vendorIdField,
      $saleIdField,
      productObj
    ) {
      $priceField.val(productObj["price"]).trigger("change")
      $nameField.val(productObj["title"])
      $vendorIdField.val(productObj["user_id"])
      $saleIdField.val(productObj["sale_campaign_id"])

      if (productObj["sale_campaign_id"]) {
        $priceField.parent().next(".js-sale-label").text("Item on Sale!")
      } else {
        $priceField.parent().next(".js-sale-label").text("")
      }
    }
  }
})
